<template>
  <div v-loading="isLoading">
    <button
      @click="handleExec()"
      class="btn btn-danger btn-fill btn-wd"
      title="Avalia os documentos verificando se há algum duplicado e remove-os do sistema"
    >
      Remover Docs dos Contemplados
    </button>
    <el-progress :percentage="progressPercentage"></el-progress>
  </div>
</template>
<script>
import Couchdb from 'src/services/Couchdb'
import swal from 'sweetalert2'

export default {
  data () {
    return {
      isLoading: false,
      progress: 0,
      total: 0
    }
  },

  computed: {
    progressPercentage () {
      if (this.total === 0) {
        return 0
      }
      let percentageTotal = parseInt((this.progress / this.total) * 100)
      if (percentageTotal > 100) {
        return 100
      }
      return percentageTotal
    }
  },

  methods: {
    handleExec () {
      this.isLoading = true
      this.progress = 0
      this.exec(response => {
        console.log('end', response)
      })
      .catch(err => console.log(err))
      .finally(response => {
        this.isLoading = false
        this.progress = 100
      })
    },
    async exec (item) {
      this.progress = 0
      let docs = await Couchdb.connection('winners').select(['_id']).where('referenceId', { $exists: true }).get()

      this.total = docs.length
      let swalOptions = {
        title: `Existem ${this.total} documentos no banco de contemplados.`
      }

      if (this.total === 0) {
        swal({
          title: swalOptions.title,
          text: `Não foi encontrados documentos no banco de contemplados.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      } else {
        swal({
          title: swalOptions.title,
          html: `Você quer os documentos do banco de contemplados para o de documentos?`,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Sim, faça isso!',
          cancelButtonText: 'Não',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
        .then(async () => {
          this.progress = 0
          for (let doc of docs) {
            let docId = doc._id

            let docWithAttachments = await Couchdb.connection('winners').find(docId)
            let attachments = docWithAttachments._attachments

            delete docWithAttachments._id
            delete docWithAttachments._rev
            delete docWithAttachments._attachments

            let newDoc = await Couchdb.connection('docs').insert(docWithAttachments)

            for (let attachment in attachments) {
              let blob = await Couchdb.connection('winners').getAttachment(docId, attachment)
              await Couchdb.connection('docs').insertAttachment(newDoc.id, {
                mimeType: attachments[attachment].content_type,
                attachmentName: attachment,
                attachment: blob
              })
              console.log('salvou o anexo no doc novo')
            }
            await Couchdb.connection('winners').delete(docId)
            this.progress++
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commands/RemoveDocsFromContemplados.vue